import axios from 'axios';
import { required } from '../../utils/validation-campaigns.utils'
import { UPLOAD_TYPES } from '../../components/apps/campaigns/constants';

const pricingClient = axios.create({
  baseURL: process.env.REACT_APP_TEMPLATE_DELIVERY_SERVICE_URI,
  timeout: 15000,
});


export const getPricingQuote = async ({
  templateType,
  uploadType,
  contacts,
  contactsFile,
}) => {
  required(templateType, 'template_type');
  required(uploadType, 'upload_type');

  if (!Object.values(UPLOAD_TYPES).includes(uploadType)) {
    throw new Error(
      `upload_type must be '${UPLOAD_TYPES.CONTACTS}' or '${UPLOAD_TYPES.FILE}'`
    );
  }

  try {
    const formData = new FormData();
    
    formData.append('template_type', templateType.toLowerCase());
    formData.append('upload_type', uploadType);

    if (uploadType === UPLOAD_TYPES.CONTACTS) {
      if (!Array.isArray(contacts) || contacts.length === 0) {
        throw new Error('contacts array is required when upload_type is "contacts"');
      }

      const phones = contacts
        .map((c) => c?.telefono || c?.phone || c)
        .filter(Boolean);

      if (phones.length === 0) {
        throw new Error('contacts must include at least one valid phone number');
      }

      formData.append('contacts', JSON.stringify(phones));
    } else if (uploadType === UPLOAD_TYPES.FILE) {
      if (!contactsFile) {
        throw new Error('contacts_file is required when upload_type is "file"');
      }

      formData.append('contacts_file', contactsFile, contactsFile.name);
    }

    const { data } = await pricingClient.post('/pricing/quote/contacts', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return data;
  } catch (error) {
    console.error('Error al obtener pricing:', error);
    
    if (error.response?.data?.detail) {
      throw new Error(error.response.data.detail);
    }
    
    throw error;
  }
};